const e = new URL("../../../assets/image-chicken-Bb8rmlJ5.png", import.meta.url).href;
export {
  e as default
};
//# sourceMappingURL=image-chicken.png.js.map
